import { setDocumentTitle } from '../services/global';
import Immutable from 'immutable';

// TODO: Move isFrench and isMobile out of client and into "Browser" reducer
const clientRecord = Immutable.Record({
    name: "",
    handle: "",
    rollout: 1,
    chat: true,
    tint: "",
    showLogo: false,
    isFrench: false,
    isMobile: false
});

const initialClientState = new clientRecord();

const client = (state = initialClientState, action) => {

    switch (action.type) {
        case 'SET_CLIENT':
        // Needed to set default client french value
            const 
                navigatorLanguage = navigator.language || navigator.userLanguage,
                navigatorIsFrench = (navigatorLanguage === 'fr' || navigatorLanguage === 'fr-ca'),
                handleIsFrench = action.response.client.handle.indexOf('-fr') !== -1,
                isMobile = Array.isArray(navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i));

            const 
                clientResponse = action.response.client,
                objectToMerge = {
                    name: clientResponse.name,
                    handle: clientResponse.handle,
                    rollout: clientResponse.rollout,
                    chat: clientResponse.chat,
                    tint: clientResponse.tint || "#22bbda",
                    showLogo: clientResponse.show_logo,
                    isFrench: navigatorIsFrench || handleIsFrench,
                    isMobile
                };

            // Set the document title
            setDocumentTitle(objectToMerge);

            return state.merge(objectToMerge);
        default:
            return state;
    }
}

export default client;


// WEBPACK FOOTER //
// ./src/reducers/client.js